import { QuotationCommercialItem } from './quotation-commercial-item.model';

export class QuotedItem {
    quotationCommercialItem?: QuotationCommercialItem;
    metaData?: any;
}
